import { Api } from '../api';
import { IResponseComunicacao, ICreateComunicacao,IResponseHelptag,IResponseComunicacaoLog } from 'shared/types';





const getAll = async (org: number, filter = ''): Promise<IResponseComunicacao | Error> => {
  try {

    const { data, status } = await Api.get(`/Orgs/${org}/ConfCom/${filter !== '' ? '?' : ''}${filter}`);


    if (data) {
      return data.retornoPagina;
    }

    if (status === 204) {
      return { rows: [], count: 0 };
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};
const getById = async (idComunicacao: string, org: number): Promise<IResponseComunicacao | Error> => {
  try {
    const { data, status } = await Api.get(`/Orgs/${org}/ConfCom?idComunicacao=${idComunicacao}`);

    if (data) {

      return data.retornoPagina;
    }

    if (status === 204) {
      return { rows: [], count: 0 };
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

const create = async (idorg: number, dados: ICreateComunicacao, tipoComunic: string): Promise<string | Error> => {
  try {
    dados.ComunicacaoTipo = tipoComunic;
    const { data, status } = await Api.post(`/Orgs/${idorg}/ConfCom/`, dados);
    if (data) {
      const { erro } = data;
      if (erro) {
        return new Error(`${erro.mensagem} - ${erro.descricao}`);
      }
      if (status > 299) {
        if('retorno' in data){
          return new Error(data.retorno);
        }
        const chaves = Object.keys(data.errors); // Acessar a primeira chave const primeiraPropriedade = chaves[0];

        return new Error(data.errors[chaves[0]][0]);

      }
      return data;
    }
    return new Error('Erro ao criar o registro.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao criar o registro.');
  }
};

const update = async (idorg: number, idCOm: number, dados: ICreateComunicacao, tipoComunic: string): Promise<void | Error> => {
  try {
    dados.ComunicacaoTipo = tipoComunic;
    const { data, status } = await Api.put(`/Orgs/${idorg}/ConfCom/${idCOm}`, dados);
    const { erro } = data;
    console.log(data);
    if (erro) {
      return new Error(`${erro.mensagem} - ${erro.descricao}`);
    }
    if (status > 299) {
      return new Error(data.retorno);
    }
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao atualizar o registro.');
  }
};




const deleteD = async (org: string): Promise<void | Error> => {
  try {
    const { data, status } = await Api.delete(`/Orgs/${org}/FornecedoraOrg/${org}`);
    const { erro } = data;
    if (erro) {
      return new Error(`${erro.mensagem} - ${erro.descricao} - ${JSON.stringify(erro.restricoes)}`);
    }
    if (status > 299) {
      return new Error(data);
    }
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao apagar o registro.');
  }
};

const getTags = async ( filter = ''): Promise<IResponseHelptag | Error> => {
  try {

    const { data, status } = await Api.get(`/DadosVariaveis/Todos/${filter !== '' ? '?' : ''}${filter}`);


    if (data) {
      return data;
    }

    if (status === 204) {
      return { rows: [], count: 0 };
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

const getAllLogs = async (  filter = ''): Promise<IResponseComunicacaoLog | Error> => {
  try {

    const { data, status } = await Api.get(`/Orgs/ComunicacaoLog/${filter !== '' ? '?' : ''}${filter}`);


    if (data) {
      return data.retornoPagina;
    }

    if (status === 204) {
      return { rows: [], count: 0 };
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

export const ComunicacaoService = {

  getAll,
  getById,
  create,
  update,
  deleteD,
  getTags,
  getAllLogs

};
